import { platformRoleAccess, platformRoleAccessAny } from "helpers/RolesPermission";

export const canViewPlatformNavItem = (item) => {
  if (item.platformPermissions?.length) {
    return platformRoleAccessAny(item.platformPermissions);
  }

  if (!item.platformPermission) {
    return true;
  }

  return platformRoleAccess(item.platformPermission);
};

export const isPlatformNavItemActive = (item, pathname) => {
  if (!item || !pathname) {
    return false;
  }

  if (item.matchPrefixes?.length) {
    return item.matchPrefixes.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    );
  }

  if (item.to && (pathname === item.to || pathname.startsWith(`${item.to}/`))) {
    return true;
  }

  if (item.current && pathname.includes(item.current)) {
    return true;
  }

  return false;
};

export const filterSuperAdminNavigationSections = (sections) =>
  sections
    .map((section) => ({
      ...section,
      items: section.items.filter(canViewPlatformNavItem),
    }))
    .filter((section) => section.items.length > 0);

export const flattenSuperAdminNavigation = (sections) =>
  filterSuperAdminNavigationSections(sections).flatMap((section) => section.items);

export const getDefaultPlatformAdminRoute = (sections) => {
  const firstItem = flattenSuperAdminNavigation(sections)[0];
  return firstItem?.to || "/dashboard";
};
